import { render, staticRenderFns } from "./fkjz_bm.vue?vue&type=template&id=bbf14482&scoped=true&"
import script from "./fkjz_bm.vue?vue&type=script&lang=js&"
export * from "./fkjz_bm.vue?vue&type=script&lang=js&"
import style0 from "./fkjz_bm.vue?vue&type=style&index=0&id=bbf14482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf14482",
  null
  
)

export default component.exports